// @ts-nocheck
import getDomPath from "./dompath.ts";
import log from "./util/log.ts";

// Initialize configuration object for the application
let verbosConfig = {
    interactiveMode: false
};

let disableScroll = false;

const loadEditor = (sendMessage, targetOrigin, getTargetLanguage = () => { }, observer) => {

    log('Editor reset')
    if(document.readyState === 'complete'){
        log('Editor loaded')
        sendMessage({
            type: 'loaded',
            lang: getTargetLanguage()
        });
    }

    const controller = new AbortController();

    if (window.top === window.self) return;

    window.selectedElement = null;

    log(`Editor target language: ${getTargetLanguage()}`)

    // Listen for 'message' events from the parent window
    window.addEventListener('message', async function (e) {
        // Ignore messages from origins other than 'http://localhost:3000'
        if (e.origin !== targetOrigin) return;

        // stop observer
        observer.disconnect()

        if (e.data.type === 'config') {
            // Update the configuration with data received from the message
            verbosConfig = e.data.config;
            // Call function to add listeners to elements after configuration update
            addListenersToVerbosElements();
            log('Config updated.')
            console.log(window.history)
        }

        if (e.data.type === 'navigation') {

            if(e.data.direction === 'forward'){
                window.history.forward()
            }

            if(e.data.direction === 'back'){
                window.history.back()
            }

            log('Navigated ' + e.data.direction)

            return;
        }

        if (e.data.type === 'itemHover') {
            // Add a class to the element on hover
            let element = document.querySelector(e.data.path);
            element.classList.add('verbosTextHover');
            if (element) {
                if (!disableScroll) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }

        if (e.data.type === 'itemValue') {
            // Add a class to the element on hover
            let element = document.querySelector(e.data.path);
            element.innerText = e.data.value;
        }

        if (e.data.type === 'itemClick') {

            disableScroll = true

            // remove all the focus classes
            let elements = document.querySelectorAll('.verbosTextFocus');
            elements.forEach(element => {
                element.classList.remove('verbosTextFocus');
            });

            // Add a class to the element on click
            let element = document.querySelector(e.data.path);
            element.classList.add('verbosTextFocus');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        if (e.data.type === 'unselectItem') {

            disableScroll = false

            // remove all the focus classes
            let elements = document.querySelectorAll('.verbosTextFocus');
            elements.forEach(element => {
                element.classList.remove('verbosTextFocus');
                element.classList.remove('verbosTextHover');
            });

        }

        if (e.data.type === 'itemLeave') {
            // Add a class to the element on hover
            document.querySelector(e.data.path).classList.remove('verbosTextHover');
        }

        // Start observing the document body for DOM changes
        observer.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true
        });

    });

    // Listen for custom 'locationchange' events
    window.addEventListener('locationchange', function () {
        // Send location change message to parent window
        sendMessage({
            type: 'locationchange',
            location: window.location.href
        });
    });

    // Override the history.pushState function to detect URL changes
    let pushState = history.pushState;
    history.pushState = function () {
        // Apply the original pushState function
        pushState.apply(history, arguments);

        // Send a location change message after URL change
        sendMessage({
            type: 'locationchange',
            location: window.location.href
        });
    };

    // Send an initial location change message
    sendMessage({
        type: 'locationchange',
        location: window.location.href
    });

    // Function to inject CSS into the document
    const injectCSS = css => {
        let el = document.createElement('style');
        el.type = 'text/css';
        el.innerText = css;
        document.head.appendChild(el);
        return el;
    };

    // Inject custom CSS for .verbosText elements
    injectCSS(`
    .verbosText:hover, .verbosTextHover { 
      outline: 2px dashed blue !important; outline-offset: 10px !important;  
    }
    .verbosText:focus, .verbosTextFocus { 
      outline: 2px dashed green !important; outline-offset: 10px !important;  
    }
  `);

    // Function to add event listeners to elements with class 'verbosText'
    const addListenersToVerbosElements = () => {
        var verbosElements = document.getElementsByClassName('verbosText');

        for (var i = 0; i < verbosElements.length; i++) {
            // Remove any existing click and blur event listeners
            verbosElements[i].removeEventListener('click', () => { });
            verbosElements[i].removeEventListener('blur', () => { });
            verbosElements[i].removeEventListener('mouseover', () => { });
            verbosElements[i].removeEventListener('mouseout', () => { });
            verbosElements[i].removeEventListener('keydown', () => { });

            // Add click event listener
            verbosElements[i].addEventListener('click', e => {
                // Prevent default action if not in interactive mode
                if (!verbosConfig.interactiveMode) {
                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    return;
                }

                // set the selected element
                window.selectedElement = e.target;

                let elements = document.querySelectorAll('.verbosTextFocus');
                elements.forEach(element => {
                    element.classList.remove('verbosTextFocus');
                });

                // Send a message on click with details of the clicked element
                sendMessage({
                    type: 'click',
                    path: getDomPath(e.target)
                });

                // Make the element editable
                e.target.contentEditable = 'true';
                e.target.focus()
                disableScroll = true
            });

            // Add blur event listener
            verbosElements[i].addEventListener('blur', e => {
                // Disable content editing on blur
                e.target.contentEditable = 'false';
                disableScroll = false

                observer.disconnect()

                if (window.selectedElement === null) return;

                if (window.selectedElement === e.target) {
                    window.selectedElement = null;
                    sendMessage({
                        type: 'updateItem',
                        translation: e.target.innerText,
                        id: e.target.getAttribute('data-verbos-id'),
                        path: getDomPath(e.target)
                    });
                    console.log('##### blur')

                }

                observer.observe(document.body, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });

            });

            // Add keyup event listener
            verbosElements[i].addEventListener('keydown', e => {

                observer.disconnect()

                if (e.key === 'Enter' && e.shiftKey) {
                    return;
                }

                if (e.key === 'Enter') {
                    e.stopPropagation();
                    e.preventDefault();
                    e.target.blur();
                }
            });


            // Add mouse over event listener
            verbosElements[i].addEventListener('mouseover', e => {

                sendMessage({
                    type: 'itemHover',
                    path: getDomPath(e.target)
                });

            });

            // Add mouse over event listener
            verbosElements[i].addEventListener('mouseout', e => {

                sendMessage({
                    type: 'itemLeave',
                    path: getDomPath(e.target)
                });

            });


        }
    };

    // Invoke the function to add listeners
    addListenersToVerbosElements();
}

export default loadEditor;